import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Message } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';
import {
    HarvestEventErrorMessage,
    HarvestEventsProps
} from 'services/harvestEvents/types';

// Global Selectors
import { makeSelectHarvestEventErrorMessage } from 'services/harvestEvents/selectors';

type OwnProps = HarvestEventsProps;

interface ConnectedProps {
    errorMessage?: HarvestEventErrorMessage;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventErrorMessageComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { errorMessage } = this.props;
        if (!errorMessage) {
            return null;
        }
        return <Message error>{errorMessage}</Message>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    errorMessage: makeSelectHarvestEventErrorMessage()
});

export default connect(mapStateToProps)(HarvestEventErrorMessageComponent);
